export const GET_SINGLE_PATIENT_ALERT =
  'singlePatientAlert/getSinglePatientAlert'
